<template>
    <ul>
      <li v-for="item in this.$store.getters.mainMenu" :key="item.id" >
        <a :ref="'main-'+item.id"
           :href="item.url"
           :class="[item.hasSub ? subLinkClass : '',item.active ? activeLinkClass : '',item.current ? currentLinkClass : '' ]"
           v-on:click="activateMenuItem($event,item)">
          {{ item.name }}
        </a>
        <ResponsiveSubMenu v-if="item.hasSub" :parent-active="item.active" :submenuItems="item.subMenu" />
      </li>

    </ul>
</template>

<script>

import ResponsiveSubMenu from "@/Components/ResponsiveSubMenu";

export default {

  name: 'ResponsiveMainMenu',
  components:{
    ResponsiveSubMenu
  },
  data() {
    return {
      subLinkClass: 'has-sub',
      activeLinkClass: 'active',
      currentLinkClass:'current'
    }
  },
  methods: {
    activateMenuItem(event,item){
      const ref = 'main-' + item.id;
      if (item.hasSub){
        event.preventDefault();
        const elementInformation = {
          id:item.id,
          positionLeft: this.$refs[ref].getBoundingClientRect().left,
        }
        this.$store.commit('setMainMenuElementActive', elementInformation);
      }
    },
  },
  // beforeMount() {
  //   //this.$store.dispatch('loadMenuItems');
  // }
}
</script>


